export function convertToTitleCase (inputText) {
  if (!inputText) {
    return '';
  }
  return inputText.replace(/([a-z])([A-Z])/g, (match, firstChar, secondChar) =>  `${firstChar} ${secondChar}`);
}

export  function convertToTitleCaseAndCapitalizeFirst (inputText) {
  const titleCaseText = convertToTitleCase(inputText);
  return titleCaseText.charAt(0).toUpperCase() + titleCaseText.slice(1);
}
  
export function isUnauthorized (errResponse) {
  return errResponse && errResponse.response && errResponse.response.status === 401;
}
